export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/a70fe28c30edbe909cade8425716fdee.svg";